export const cameraInitialPosition = {
  desktop: [13.750061613249478, 10, 13.823624319788875],
  mobile: [24.340123505652443, 16.324186649232594, 25.927875821449923],
};

export const orbitControlsTarget = {
  desktop: [-0.8783316342959402, 3.5, -1.7424402227468443],
  mobile: [-1.3778645865330086, 3, -1.438617629177433],
};

export const cameraPositionScreenFocused = {
  desktop: [0.2515280978008181, 4.988123364914528, -0.21274060534842104],
  mobile: [4.349495573654094, 5.38194341092947, -0.10939316601277108],
};

export const orbitControlsTargetScreenFocused = {
  desktop: [-1.116969, 4.856609, -0.247253],
  mobile: [-1.116969, 4.856609, -0.247253],
};

export const cameraPositionCertificateFocused = {
  desktop: [-0.9940293876010273, 7.147, -0.9385869485290291],
  mobile: [4.676922172049715, 7.185, -0.902667296765468],
};

export const orbitControlsTargetCertificateFocused = {
  desktop: [-2.751214, 7.092, -0.949717],
  mobile: [-2.751213707816067, 6.952, -0.9497167208797691],
};
